import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetProjectQuery = (
  projectId: string,
  workspaceSlug?: string
) => {
  const { authApi } = useAuth();

  const path = workspaceSlug
    ? `/project/${projectId}?workspace=${workspaceSlug}`
    : `/project/${projectId}`;

  const result = useQuery({
    queryKey: workspaceSlug
      ? ["project", projectId, workspaceSlug]
      : ["project", projectId],
    queryFn: async () => {
      const { data } = await authApi.get<Project>(path);
      return data;
    },
  });

  return result;
};
